<template>
  <div>
    <a
      v-tooltip.bottom="$t('client.labels.helpcenter')"
      class="flex size-8 cursor-pointer items-center justify-center rounded-full text-neutral-500 transition-colors duration-150 hover:bg-primary-100 hover:text-neutral-800"
      data-test="dropdown-help"
      @click="toggleHelpMenu"
    >
      <FontAwesomeIcon :icon="['far', 'circle-question']" />
    </a>

    <PMenu
      ref="help_menu_ref"
      :model="help_items"
      :popup="true"
    >
      <template #item="{ item, props }">
        <a
          v-if="item.action === 'intercom'"
          data-test="help-intercom"
          v-bind="props.action"
          @click="openIntercom"
        >
          <div class="flex items-center gap-2">
            <FontAwesomeIcon
              :icon="['far', 'comment']"
              fixed-width
            />
            <span>{{ $t(item.label) }}</span>
          </div>
        </a>
        <a
          v-else-if="item.action === 'helpcenter'"
          :href="help_url"
          target="_blank"
          rel="noopener"
          data-test="help-helpcenter"
          v-bind="props.action"
        >
          <div class="flex items-center gap-2">
            <FontAwesomeIcon
              :icon="['far', 'circle-question']"
              fixed-width
            />
            <span>{{ $t(item.label) }}</span>
          </div>
        </a>
        <a
          v-else-if="item.action === 'book_demo'"
          href="https://meetings.hubspot.com/marcus-vanhoonacker/video-call-45"
          target="_blank"
          rel="noopener"
          data-test="help-book-demo"
          v-bind="props.action"
        >
          <div class="flex items-center gap-2">
            <FontAwesomeIcon
              :icon="['far', 'calendar']"
              fixed-width
            />
            <span>{{ $t(item.label) }}</span>
          </div>
        </a>
      </template>
    </PMenu>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';

import { Tenant } from '@/app/data/model_constants';

const store = useStore();

const help_menu_ref = ref(null);

const current_profile = computed(() => store.getters.current_profile);
const current_client = computed(() => store.getters.current_client);

const client_is_trial = computed(
  () => current_client.value && current_client.value.attributes.status === Tenant.STATUS_TRIAL,
);

const help_url = computed(() => {
  if (!current_profile.value) return '';
  return `https://help.ziggu.app/${current_profile.value.attributes.language}/collections/10399348`;
});

const help_items = computed(() => [
  { label: 'client.labels.chatWithUs', action: 'intercom' },
  { label: 'client.labels.helpcenter', action: 'helpcenter' },
  ...(client_is_trial.value ? [{ label: 'client.labels.bookADemo', action: 'book_demo' }] : []),
]);

function toggleHelpMenu(event) {
  help_menu_ref.value.toggle(event);
}

function openIntercom() {
  window.Intercom('show');
}
</script>
